import script from "./LcForm.vue?vue&type=script&setup=true&lang=js"
export * from "./LcForm.vue?vue&type=script&setup=true&lang=js"

import "./LcForm.vue?vue&type=style&index=0&id=0ebdcdd5&scoped=true&lang=css"

import exportComponent from "/Users/alberto/sites/newform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ebdcdd5"]])

export default __exports__